import {Vat, vatDecoder} from './Vat'
import {Decoder, object, field, number, array} from 'json-bouncer'

export interface Totals {
    readonly calculatedShippingCosts: number
    readonly netPrice: number
    readonly vats: Vat[]
    readonly grossPrice: number
}

export function totalsDecoder(): Decoder<Totals> {
    return object({
        calculatedShippingCosts: field('calculatedShippingCosts', number()),
        netPrice: field('netPrice', number()),
        vats: field('vats', array(vatDecoder())),
        grossPrice: field('grossPrice', number()),
    })
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/Totals.ts